module.exports = __webpack_public_path__ + "40135f4c8693942d8f4105b7a99c9f8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/advanced_micro_devices_2023_chart.png
// module id = 1626
// module chunks = 0